import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faClock as farClock } from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatText } from "@ui/format";
import { Button } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import type { PersonalLoanScoringResponse, PersonalLoanScoringResponseItemPair } from "../types";

interface Props extends AbstractStepProps {
	results: PersonalLoanScoringResponse;
	selectMaturity: (res: number) => void;
}

export class Result extends AbstractStep<{}, Props, {}> {
	protected renderContent(): ReactNode {
		return (
			<>
				<Card.Header className="bg-success text-white text-center">
					<Card.Title>Számodra elérhető hitelek:</Card.Title>
				</Card.Header>
				<Card.Body>{this.renderResults()}</Card.Body>
				<Card.Footer className="text-center">
					<Button type="submit">Tovább</Button>
				</Card.Footer>
			</>
		);
	}

	private renderResults(): ReactNode {
		const { results } = this.props;

		if (results) {
			return (
				<>
					{Object.keys(results.availableLoans).map((key) =>
						this.renderSingleResult(Number(key), results.availableLoans[key]),
					)}
				</>
			);
		}

		return null;
	}

	private renderSingleResult(maturity: number, result: PersonalLoanScoringResponseItemPair): ReactNode {
		const { selectMaturity } = this.props;

		return (
			<table className="table table-sm table-striped table-bordered" key={maturity}>
				<tbody>
					<tr>
						<th colSpan={2}>
							<div className="d-flex align-items-center">
								<div>
									<span className="text-danger">
										<FontAwesomeIcon icon={farClock} className="mr-1" />
										{maturity} éves
									</span>{" "}
									futamidő esetén
								</div>
								<Button
									type="submit"
									variant="success"
									size="sm"
									className="ml-auto text-uppercase font-weight-bold px-2 py-1"
									onClick={() => selectMaturity(maturity)}
								>
									Megkötöm
								</Button>
							</div>
						</th>
					</tr>
					<tr>
						<th scope="row">Hitel:</th>
						<td>
							{formatText(result[0].loanAmount, "ft")} - {formatText(result[1].loanAmount, "ft")}
						</td>
					</tr>
					<tr>
						<th scope="row">Törlesztő:</th>
						<td>
							{formatText(result[0].installment, "ft")} - {formatText(result[1].installment, "ft")}
						</td>
					</tr>
					<tr>
						<th scope="row">THM:</th>
						<td>{formatText(result[0].apr, "%")}</td>
					</tr>
				</tbody>
			</table>
		);
	}

	protected getComponentName(): string {
		return "Result";
	}
}
